import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        // Actualiza el estado para renderizar la UI de repuesto
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // 🚀 AUDITORÍA FRONTEND: Ideal para integrar con Sentry o Datadog en el futuro
        console.error("🚨 [Clínica Error Boundary] Fallo de renderizado interceptado:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-[400px] flex items-center justify-center p-6 bg-slate-50/50 rounded-[2rem] border-2 border-dashed border-slate-200 m-4 animate-fade-in">
                    <div className="text-center max-w-md">
                        {/* Icono de Alerta Suave */}
                        <div className="w-20 h-20 mx-auto mb-6 bg-red-50 text-red-500 rounded-full flex items-center justify-center shadow-inner border border-red-100">
                            <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
                            </svg>
                        </div>

                        <h2 className="text-2xl font-black text-slate-900 tracking-tight mb-2">
                            Interrupción del Módulo
                        </h2>

                        <p className="text-sm font-medium text-slate-500 mb-8 leading-relaxed">
                            El sistema ha interceptado una anomalía al renderizar esta sección. Por seguridad, la vista ha sido bloqueada.
                        </p>

                        {/* Vías de Escape */}
                        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                            <button
                                onClick={() => window.location.reload()}
                                className="w-full sm:w-auto px-6 py-3 bg-slate-900 hover:bg-slate-800 text-white text-sm font-bold rounded-xl transition-all shadow-md focus:outline-none focus:ring-4 focus:ring-slate-900/20"
                            >
                                Intentar Recargar
                            </button>
                            <button
                                onClick={() => window.location.href = '/'}
                                className="w-full sm:w-auto px-6 py-3 bg-white border border-slate-200 hover:bg-slate-50 text-slate-700 text-sm font-bold rounded-xl transition-all shadow-sm focus:outline-none focus:ring-4 focus:ring-slate-200"
                            >
                                Volver al Inicio
                            </button>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;